import { Grid, Typography } from "@mui/material";
import { OLTable, Row, createHeadItems } from "components/Table/OLTable";
import { useMessage } from "hooks/intl";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MEMBER_MATCHED_EVENT_ID } from "state/tables/types";
import { BackendMemberModel } from "types/members";
import { links } from "utilities/links";

interface Props {
  member?: BackendMemberModel;
}

export const MatchedMemberSection = ({ member }: Props) => {
  const { message } = useMessage();
  const navigate = useNavigate();

  const headItems = createHeadItems([
    {
      headerText: message({ id: "memberName" }),
      property: "memberName",
      isSortable: false,
    },
    {
      headerText: message({ id: "emailAddress" }),
      property: "emailAddress",
      isSortable: false,
    },
    {
      headerText: message({ id: "phoneNumber" }),
      property: "phone",
      align: "right",
      isSortable: false,
    },
    {
      headerText: message({ id: "loyaltyCardNumber" }),
      align: "right",
      property: "loyaltyCardNumber",
      isSortable: false,
    },
  ]);

  const createItems = (items: BackendMemberModel[]): Row[] => {
    return items.map((item) => ({
      cells: [
        {
          content: `${item.firstName} ${item.lastName}`,
          property: "memberName",
          dataHjSuppress: true,
        },
        { content: item.email, property: "emailAddress", dataHjSuppress: true },
        {
          content: item.phone,
          align: "right",
          property: "phone",
          dataHjSuppress: true,
        },
        {
          content: item.loyaltyCardNumber,
          align: "right",
          property: "loyaltyCardNumber",
          dataHjSuppress: true,
        },
      ],
      id: item.customerId as string,
    }));
  };

  const notMatchedItems: Row[] = useMemo(
    () => [
      {
        cells: [
          {
            content: message({ id: "notMatched" }),
            property: "memberName",
            dataHjSuppress: true,
          },
          { content: "-", property: "emailAddress" },
          { content: "-", property: "phone" },
          { content: "-", property: "loyaltyCardNumber" },
        ],
        id: "notMatched",
      },
    ],
    [message],
  );

  const items = member ? createItems([member]) : notMatchedItems;

  return (
    <Grid item xs={12}>
      <Typography marginBottom={6}>
        {message({ id: "memberMatchedWithCustomEvent" })}
      </Typography>

      <OLTable
        tableName={MEMBER_MATCHED_EVENT_ID}
        data-test-id="member-matched-event"
        actions={{
          body: [
            {
              action: (
                id?: string | React.MouseEvent<HTMLLIElement, MouseEvent>,
              ) => navigate(links.singleMemberCustomEvents(id as string)),
              label: message({ id: "seeMemberProfile" }),
              hideCondition: () => !member,
            },
          ],
        }}
        columns={headItems}
        onSort={() => {}}
        rows={items}
        sort={{ order: "asc", property: "", rowsPerPage: 10, page: 1 }}
      />
    </Grid>
  );
};
